import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import DetailIcon from '@mui/icons-material/Details';

function MasterIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const history = useHistory(); // Access the navigation history
    const [isFocused, setIsFocused] = useState(false);
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    //Common Data 
    const [name, setName] = useState("");
    const [Grpname, setGrpName] = useState("");
    const [searchablename, setSearchableName] = useState("");
    const [remarks, setRemarks] = useState("");

    //Owner Details / Captial
    const [ContactNumber1, setContactNumber1] = useState("");
    const [ContactNumber2, setContactNumber2] = useState("");
    const [Email, setEmail] = useState("");
    const [AddressLine1, setAddressLine1] = useState("");
    const [AddressLine2, setAddressLine2] = useState("");

    //CustomerOrSupplier
    const [CSEmail, setCSEmail] = useState("");
    const [CSAddressLine1, setCSAddressLine1] = useState("");
    const [CSAddressLine2, setCSAddressLine2] = useState("");
    const [CSDeliveryAddressLine1, setCSDeliveryAddressLine1] = useState("");
    const [CSDeliveryAddressLine2, setCSDeliveryAddressLine2] = useState("");
    const [CSContactNumber1, setCSContactNumber1] = useState("");
    const [CSContactNumber2, setCSContactNumber2] = useState("");
    const [Location, setLocation] = useState("");
    const [Pincode, setPincode] = useState("");
    const [MRPLCode, setMRPLCode] = useState("");
    const [PanNumber, setPanNumber] = useState("");
    const [GSTNumber, setGSTNumber] = useState("");
    const [CreditDays, setCreditDays] = useState("");
    const [CreditLimit, setCreditLimit] = useState("");
    const [customerType, setCustomerType] = useState(1);

    //credit radio [customer type]
    const handleChange = (event) => {
        setCustomerType(event.target.value);
    };

    //Bank 
    const [AccountName, setAccountName] = useState("");
    const [BranchName, setBranchName] = useState("");
    const [IFSCCode, setIFSCCode] = useState("");
    const [BKAddressLine1, setBKAddressLine1] = useState("");
    const [BKAddressLine2, setBKAddressLine2] = useState("");
    const [BKContactNumber, setBKContactNumber] = useState("");

    //Staff
    const [STAddressLine1, setSTAddressLine1] = useState("");
    const [STAddressLine2, setSTAddressLine2] = useState("");
    const [STContactNumber1, setSTContactNumber1] = useState("");
    const [STContactNumber2, setSTContactNumber2] = useState("");
    const [STEmail, setSTEmail] = useState("");
    const [isLoginNeeded, setIsLoginNeeded] = useState(false);
    // if IsloginNeeded is true then display the firstname and second name feilds
    const [STFirstName, setSTFirstName] = useState("");
    const [STSecondName, setSTSecondName] = useState("");
    const [STuserName, setSTUserName] = useState("");

    useEffect(() => {
        const generatedUserName = `${STFirstName.toLowerCase()}_${STSecondName.toLowerCase()}`;
        // Limit the username to a maximum length of 15 characters
        const limitedUserName = generatedUserName.slice(0, 12);
        setSTUserName(limitedUserName);

    }, [STFirstName, STSecondName]);

    //AccountHead
    const [CGSTRate, setCGSTRate] = useState("");
    const [SGSTRate, setSGSTRate] = useState("");
    const [HSNCode, setHSNCode] = useState("");
    const [IsExpenseOrIncome, setIsExpenseOrIncome] = useState(true);

    const handleAccoundHeadChange = (event) => {
        const value = event.target.value === "true"; // Converts "true"/"false" string to boolean
        setIsExpenseOrIncome(value);
    };

    //Assets
    const [ATAmount, setATAmount] = useState("");
    const [ATCGSTRate, setATCGSTRate] = useState("");
    const [ATSGSTRate, setATSGSTRate] = useState("");
    const [ATHSNCode, setATHSNCode] = useState("");
    const [ATDepreciation, setATDepreciation] = useState("");

    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

        // Token is not expired, fetch data
        // fetchtableData();
    }, [isAuthenticated, companyId, userId, token, logout]);

    // useEffect(() => {
    //     if (searchTerm.trim() === '') {
    //         setFilteredData(data);
    //     } else {
    //         const filtered = data.filter(item => item.name && item.name.toLowerCase().includes(searchTerm.toLowerCase()));
    //         setFilteredData(filtered);
    //     }
    // }, [data, searchTerm]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const SearchfilteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const handleActivate = (itemId) => {
        activateData('CategoryApi', `${itemId}`)
            .then(() => {
                //fetchtableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    //Balance Sheet
    const [balancesheetOptions, setBalanceSheetOptions] = useState([]);
    const [selectedBalanceSheetType, setSelectedBalanceSheetType] = useState("");

    const fetchBalanceSheet = async () => {
        try {
            const response = await fetchData('MasterApi', `/BalanceSheetData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(balance => ({
                    value: balance.Id,
                    label: balance.Name
                }));
                setBalanceSheetOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleBalanceSheetChange = (selectedOption) => {
        setSelectedBalanceSheetType(selectedOption);
    };

    useEffect(() => {
        fetchBalanceSheet();
    }, []);

    //Master Group 
    const [GrpMasterTypeOptions, setGrpMasterTypeOptions] = useState([]);
    const [selectedGrpMasterType, setGrpSelectedMasterType] = useState("");
    const [selectedGrpMasterTypeId, setSelectedGrpMasterTypeId] = useState("");

    const fetchMasterGroup = async () => {
        try {

            const response = await fetchData('MasterGroup', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(master => ({
                    value: master.Id,
                    label: master.Name
                }));
                setGrpMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching MasterGroup:', error);
        }
    };

    const handleGrpMasterTypeChange = (selectedOption) => {
        setGrpSelectedMasterType(selectedOption.label);
        setSelectedGrpMasterTypeId(selectedOption.value);
    };

    //MasterType
    const [MasterTypeOptions, setMasterTypeOptions] = useState([]);
    const [selectedMasterType, setSelectedMasterType] = useState("");
    const [selectedMasterTypeId, setSelectedMasterTypeId] = useState("");

    const fetchMasterType = async () => {
        try {
            const response = await fetchData('MasterApi', `/MasterTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(master => ({
                    value: master.Id,
                    label: master.Name
                }));
                setMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleMasterTypeChange = (selectedOption) => {
        setSelectedMasterType(selectedOption.label);
        setSelectedMasterTypeId(selectedOption.value);
    };

    useEffect(() => {
        fetchMasterType();
        fetchMasterGroup();
    }, []);

    //Staff
    const [StaffOptions, setStaffOptions] = useState([]);
    const [selectedStaff, setSelectedStaff] = useState("");

    const fetchStaff = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('StaffApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(staff => ({
                    value: staff.id,
                    label: staff.name
                }));
                setStaffOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handlestaffChange = (selectedOption) => {
        setSelectedStaff(selectedOption);
    };

    useEffect(() => {
        fetchStaff();
    }, []);

    //MasterType FOR INDEX
    const [IndexMasterTypeOptions, setIndexMasterTypeOptions] = useState([]);
    const [selectedIndexMasterType, setSelectedIndexMasterType] = useState("");
    const [selectedIndexMasterTypeData, setSelectedIndexMasterTypeData] = useState("");
    const [selectedIndexMasterTypeId, setSelectedIndexMasterTypeId] = useState("");

    const fetchIndexMasterType = async () => {
        try {
            const response = await fetchData('MasterApi', `/MasterTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(indexmaster => ({
                    value: indexmaster.Id,
                    label: indexmaster.Name
                }));
                setIndexMasterTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleIndexMasterTypeChange = async (IndexMasterselectedOption) => {
        // Set selected master type details
        setSelectedIndexMasterType(IndexMasterselectedOption);
        setSelectedIndexMasterTypeData(IndexMasterselectedOption.label);
        setSelectedIndexMasterTypeId(IndexMasterselectedOption.value);
        const selectedLabel = IndexMasterselectedOption.value;

        try {
            if (selectedLabel === 1) {
                const response = await fetchData('CapitalApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 2) {
                const response = await fetchData('SupplierApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 3) {
                const response = await fetchData('BankApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 4) {
                const response = await fetchData('AccountHeadApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else if (selectedLabel === 5) {
                const response = await fetchData('MasterApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
            else {
                const response = await fetchData('AssetsApi', `/${companyId}/${IndexMasterselectedOption.value}`, token);

                if (response.responseCode === '1111') {
                    const dataArray = response.response_data;
                    // Process dataArray if needed
                    setData(dataArray);
                }
            }
        } catch (error) {
            console.error('Error fetching Sale Details:', error);
        }
    };

    useEffect(() => {
        fetchIndexMasterType();
    }, []);

    //  Invoice Type
    const [InvoiceTypeOptions, setInvoiceTypeOptions] = useState([]);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState("");

    const fetchInvoiceType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('MasterApi', `/InvoiceTypeData/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(invoice => ({
                    value: invoice.Id,
                    label: invoice.Name
                }));
                setInvoiceTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleInvoiceTypeChange = (selectedOption) => {
        setSelectedInvoiceType(selectedOption);
    };

    useEffect(() => {
        fetchInvoiceType();
    }, []);

    // Branch Select for Staff Creation
    const [BranchTypeOptions, setBranchTypeOptions] = useState([]);
    const [selectedBranchType, setSelectedBranchType] = useState("");

    const fetchBranchType = async () => {
        try {
            // const response = await fetchData('MasterApi', `/${companyId}`, token);
            const response = await fetchData('BranchApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {

                const options = response.response_data.map(branch => ({
                    value: branch.Id,
                    label: branch.Name
                }));
                setBranchTypeOptions(options);
            }
        } catch (error) {
            console.error('Error fetching route:', error);
        }
    };

    const handleBranchTypeChange = (selectedOption) => {
        //setSelectedMasterType(selectedOption);
        setSelectedBranchType(selectedOption);
    };

    useEffect(() => {
        fetchBranchType();
    }, []);

    //Create Model Open
    const [isModalOpen, setIsModalOpen] = useState(false);
    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const addRecord = async (e) => {
        e.preventDefault();

        if (selectedMasterType === "Staff") {

            const StaffData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                ContactNumber1: STContactNumber1,
                ContactNumber2: STContactNumber2,
                Email: STEmail,
                AddressLine1: STAddressLine1,
                AddressLine2: STAddressLine2,
                CreatedBy: userId,
                CreatedDate: new Date(),
                IsLoginNeeded: isLoginNeeded,
                FirstName: STFirstName,
                LastName: STSecondName,
                UserName: STuserName,
                BranchId: selectedBranchType.value,

            };

            postData('StaffApi', StaffData, token)
                .then((response) => {
                    console.log('Staff Created success:', response);
                    setSuccessMessage("Staff Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setSTFirstName("");
                    setSTSecondName("");
                    setSTUserName("");
                    setSelectedBalanceSheetType("");
                    setSTContactNumber1("");
                    setSTContactNumber2("");
                    setSTAddressLine1("");
                    setSTAddressLine2("");
                    setSTEmail("");
                    setSelectedMasterType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Item Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Assets") {

            const AssetsData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                Amount: ATAmount,
                Depreciation: ATDepreciation,
                CGSTRate: ATCGSTRate,
                SGSTRate: ATSGSTRate,
                HSNCode: ATHSNCode,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('AssetsApi', AssetsData, token)
                .then((response) => {
                    console.log('Assets Created success:', response);
                    setSuccessMessage("Assets Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setATAmount("");
                    setATCGSTRate("");
                    setATSGSTRate("");
                    setATDepreciation("");
                    setATHSNCode("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    // fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Assets Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Bank") {

            const BankData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                AccountName: AccountName,
                BranchName: BranchName,
                IFSCCode: IFSCCode,
                AddressLine1: BKAddressLine1,
                AddressLine2: BKAddressLine2,
                ContactNumber: BKContactNumber,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('BankApi', BankData, token)
                .then((response) => {
                    console.log('Bank Created success:', response);
                    setSuccessMessage("Bank Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setBKAddressLine1("");
                    setBKAddressLine2("");
                    setBKContactNumber("");
                    setAccountName("");
                    setBranchName("");
                    setIFSCCode("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Bank Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Capital") {

            const CapitalData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                ContactNumber1: ContactNumber1,
                ContactNumber2: ContactNumber2,
                Email: Email,
                AddressLine1: AddressLine1,
                AddressLine2: AddressLine2,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('CapitalApi', CapitalData, token)
                .then((response) => {
                    console.log('CapitalData Created success:', response);
                    setSuccessMessage("CapitalData Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setAddressLine1("");
                    setAddressLine2("");
                    setContactNumber1("");
                    setContactNumber2("");
                    setEmail("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('CapitalData Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Supplier") {

            const CustomerOrSupplierData = {

                MasterId:0,
                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                ContactNumber1: CSContactNumber1,
                ContactNumber2: CSContactNumber2,
                Email: CSEmail,
                AddressLine1: CSAddressLine1,
                AddressLine2: CSAddressLine2,
                DeliveryAddressLine1: CSDeliveryAddressLine1,
                DeliveryAddressLine2: CSDeliveryAddressLine2,
                Location: Location,
                PinCode: Pincode,
                GSTNumber: GSTNumber,
                PanNumber: PanNumber,
                MRPLCode: MRPLCode,
                CreditDays: CreditDays,
                CreditLimit: CreditLimit,
                CustomerType: 1,
                CreatedBy: userId,
                CreatedDate: new Date(),
                InvoiceTypeId: selectedInvoiceType.value,

            };

            postData('SupplierApi', CustomerOrSupplierData, token)
                .then((response) => {
                    console.log('SupplierData Created success:', response);
                    setSuccessMessage("SupplierData Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setCSAddressLine1("");
                    setCSAddressLine2("");
                    setCSDeliveryAddressLine1("");
                    setCSDeliveryAddressLine2("");
                    setCSContactNumber1("");
                    setCSContactNumber2("");
                    setCSEmail("");
                    setLocation("");
                    setGSTNumber("");
                    setPanNumber("");
                    setSelectedInvoiceType("");
                    //setSelectedSalesManType("");
                    setMRPLCode("");
                    setPincode("");
                    setCreditDays("");
                    setCreditLimit("");
                    setCustomerType("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('SupplierData Create error:', error);
                    setIsLoading(false);
                });
        }

        else if (selectedMasterType === "Account Head") {

            const AccountHeadData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                CGSTRate: CGSTRate,
                SGSTRate: SGSTRate,
                HSNCode: HSNCode,
                IsExpenseOrIncome: IsExpenseOrIncome,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('AccountHeadApi', AccountHeadData, token)
                .then((response) => {
                    console.log('Account Head Created success:', response);
                    setSuccessMessage("Account Head Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setCGSTRate("");
                    setSGSTRate("");
                    setHSNCode("");
                    setIsExpenseOrIncome("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    //fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Account Head Create error:', error);
                    setIsLoading(false);
                });
        }

        else {
            //(selectedMasterType === "Others") 
            const OtherData = {

                CompanyId: companyId,
                MasterTypeId: selectedMasterTypeId,
                BalanceSheetHeadId: selectedBalanceSheetType.value,
                Name: name,
                SearchableName: searchablename,
                Remarks: remarks,
                CreatedBy: userId,
                CreatedDate: new Date(),

            };

            postData('MasterApi', OtherData, token)
                .then((response) => {
                    console.log('Others Created success:', response);
                    setSuccessMessage("Others Created successfully!");
                    setErrorMessage("");
                    setName("");
                    setSearchableName("");
                    setRemarks("");
                    setSelectedMasterType("");
                    setSelectedBalanceSheetType("");
                    // fetchtableData();
                    setIsModalOpen(false);
                    setTimeout(() => {
                        setSuccessMessage("");
                    }, 3000);
                })
                .catch((error) => {
                    console.error('Others Create error:', error);
                    setIsLoading(false);
                });
        }
    };

    //CATEGORY EDIT 
    const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);

    const openDetailModal = async (id) => {
        try {
            const response = await fetchData('CategoryApi', `/CategoryDetails/${id}`, token);
            if (response.responseCode === '1111') {
                setUpdateData(response.response_data);
                setIsDetailModalOpen(true);
            }
        } catch (error) {
            console.error('Error fetching Item Details:', error);
        }
    };

    const toggleModalBranch = () => {
        setIsDetailModalOpen(false); // Step 2
    };

    const handleUpdateInputChange = (event) => {
        const { name, value } = event.target;
        setUpdateData((prevDataItem) => ({
            ...prevDataItem,
            [name]: value,
        }));
    };

    const [updatedData, setUpdateData] = useState({});

    const updateRecord = async (event) => {
        event.preventDefault();


        try {

            await updateData('ItemApi', `${updatedData.Id}`, updatedData, token);
            setUpdateData({
                CompanyId: companyId,
                Name: '',
                CommodityCode: '',
                OpeningstockinQTY: '',
                OpeningstockinPackets: '',
                PurchaseRate: '',
                SaleRate: '',
                PurchaseRateinPkt: '',
                SaleRateinpkt: '',
                MRP: '',
                Noofpktinacase: '',
                HSNCode: '', // new feilds
                CGSTRate: '',
                SGSTRate: '',
            });
            //fetchtableData();
            setIsDetailModalOpen(false);
        } catch (error) {
            console.error('Error updating record:', error);
        }
    };

    const [IndexcustomerType, setIndexCustomerType] = useState(1); // Default to Customer

    const handleCustomerTypeChange = (event) => {
        setCustomerType(Number(event.target.value));
    };

    // Filter data based on customer type
    const filteredIndexData = data.filter(item => {
        if (customerType === 1) return item.customerType === 1; // Customer
        if (customerType === 2) return item.customerType === 2; // Supplier
        if (customerType === 3) return item.customerType === 1 || item.customerType === 2; // Both
        return true;
    });

    const handleDelete = async () => {
        deleteData('AccountHeadApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    return (
        <div className="w-full max-w-sm container mt-2 mx-auto">
            <div className='w-full mb-2 flex'>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'monospace', color: 'black' }}>MASTER REGISTRATION</h6>
                {/* {hasCreateMasterPermission && ( */}
                <div className="w-1/3 mr-2">
                    <Select
                        value={selectedIndexMasterType}
                        onChange={handleIndexMasterTypeChange}
                        options={IndexMasterTypeOptions}
                        placeholder="Select Master Type"
                        isSearchable
                        styles={{
                            control: (provided) => ({
                                ...provided,
                                minHeight: '25px',  // Minimum height of the dropdown
                                height: '25px',
                                marginTop: '5px',
                            }),
                            valueContainer: (provided) => ({
                                ...provided,
                                height: '25px',
                                padding: '0 6px',
                            }),
                            input: (provided) => ({
                                ...provided,
                                margin: 0,
                                padding: 0,
                            }),
                            indicatorsContainer: (provided) => ({
                                ...provided,
                                height: '25px',
                            }),
                        }}
                    />
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: '10px',
                    }}
                >
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '25px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                            marginTop: '5px',
                        }}
                    />
                </div>
                <Tooltip
                    title="Personal Registration"
                    arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'darkred',
                                color: 'white',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{
                            background: 'linear-gradient(90deg, #08504fff, #ff4b2b)',
                            borderRadius: '25px',
                            padding: '5px 15px',
                            color: 'white',
                            fontWeight: 'bold',
                            border: 'none',
                            textTransform: 'uppercase',
                            letterSpacing: '1px',
                            boxShadow: '0 4px 10px rgba(255, 64, 64, 0.4)',
                            transition: 'all 0.3s ease',
                            maxHeight: '22px',
                            marginLeft: '15px',
                            fontSize: '12px',
                            marginTop: '5px'
                        }}
                        onMouseOver={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 6px 15px rgba(255, 64, 64, 0.6)';
                        }}
                        onMouseOut={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = '0 4px 10px rgba(255, 64, 64, 0.4)';
                        }}
                        onClick={toggleModal}
                    >
                        Registration
                    </Button>
                </Tooltip>

            </div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-10">
                    <div className="p-6 rounded-lg shadow-lg" style={{ background: '#27445D', width: '1100px' }}>

                        {selectedMasterType !== "Capital" && selectedMasterType !== "Supplier" &&
                            selectedMasterType !== "Bank" && selectedMasterType !== "Staff" &&
                            selectedMasterType !== "Account Head" && selectedMasterType !== "Assets" &&
                            selectedMasterTypeId !== "Others" && (
                                <h6 className="text-center font-bold" style={{ fontFamily: 'monospace', color: 'whitesmoke' }}>
                                    MASTER REGISTRATION
                                </h6>
                            )}

                        {selectedMasterType === "Capital" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'monospace', color: 'whitesmoke' }}>CAPITAL</h6>
                        )}
                        {selectedMasterType === "Supplier" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'monospace', color: 'whitesmoke' }}>SUPPLIER</h6>
                        )}
                        {selectedMasterType === "Bank" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'monospace', color: 'whitesmoke' }}>BANK</h6>
                        )}
                        {selectedMasterType === "Staff" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'monospace', color: 'whitesmoke' }}>STAFF</h6>
                        )}
                        {selectedMasterType === "Account Head" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'monospace', color: 'whitesmoke' }}>ACCOUNT HEAD</h6>
                        )}
                        {selectedMasterType === "Assets" && (
                            <h6 className="text-center  font-bold" style={{ fontFamily: 'monospace', color: 'whitesmoke' }}>ASSET</h6>
                        )}

                        <div className="w-full mb-3 flex">

                            <div className="w-1/3 mr-2">

                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                    Balance Sheet
                                </label>
                                <Select
                                    value={selectedBalanceSheetType}
                                    onChange={handleBalanceSheetChange}
                                    options={balancesheetOptions}
                                    placeholder="Balance sheet"
                                    isSearchable
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            minHeight: '30px',  // Minimum height of the dropdown
                                            height: '30px',
                                        }),
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: '30px',
                                            padding: '0 6px',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            height: '30px',
                                        }),
                                    }}
                                />
                            </div>
                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                    Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    type="text"
                                    name="Name"
                                    placeholder="Enter Name"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}

                                />
                            </div>
                            <div className="w-1/4 mr-2" style={{ width: '80%' }}>
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                    Searchable Name
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                    type="text"
                                    name="searchablename"
                                    placeholder="Enter Searchable Name"
                                    value={searchablename}
                                    onChange={(e) => setSearchableName(e.target.value)}

                                />
                            </div>
                        </div>

                        <div className="w-full mb-3 flex">

                            <div className="w-1/2 mr-2">
                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                    Remarks
                                </label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-Center h-8"
                                    type="text"
                                    name="remarks"
                                    placeholder="Enter Remarks"
                                    value={remarks}
                                    onChange={(e) => setRemarks(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                            </div>

                            <div className="w-1/3 mr-2">

                                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="name" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                    Master Type
                                </label>

                                <Select
                                    value={MasterTypeOptions.find(option => option.label === selectedMasterType)}  // Match the selected option by label
                                    onChange={handleMasterTypeChange}
                                    options={MasterTypeOptions}
                                    placeholder="Master Type"
                                    isSearchable
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            minHeight: '30px',  // Minimum height of the dropdown
                                            height: '30px',
                                        }),
                                        valueContainer: (provided) => ({
                                            ...provided,
                                            height: '30px',
                                            padding: '0 6px',
                                        }),
                                        input: (provided) => ({
                                            ...provided,
                                            margin: 0,
                                            padding: 0,
                                        }),
                                        indicatorsContainer: (provided) => ({
                                            ...provided,
                                            height: '30px',
                                        }),
                                    }}
                                />

                            </div>

                        </div>

                        {/* Captial */}
                        {selectedMasterType === "Capital" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Contact No 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={ContactNumber1}
                                        onChange={(e) => setContactNumber1(e.target.value)}
                                        type="text"
                                        placeholder="Contact No 1"
                                        id="ContactNumber1"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Contact No 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={ContactNumber2}
                                        onChange={(e) => setContactNumber2(e.target.value)}
                                        type="text"
                                        placeholder="Contact No 2"
                                        id="ContactNumber2"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={Email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        type="text"
                                        placeholder="Email"
                                        id="Email"
                                    />
                                </div>
                            </div>
                        )}

                        {selectedMasterType === "Capital" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Address Line 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={AddressLine1}
                                        onChange={(e) => setAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="Address Line 1"
                                        id="AddressLine1"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-green-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Address Line 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={AddressLine2}
                                        onChange={(e) => setAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="Address Line 2"
                                        id="AddressLine2"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Customer&Supplier */}

                        {selectedMasterType === "Supplier" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/4 mr-2">

                                    <label className="block uppercase tracking-wide  text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Invoice Type
                                    </label>

                                    <Select
                                        value={selectedInvoiceType}
                                        onChange={handleInvoiceTypeChange}
                                        options={InvoiceTypeOptions}
                                        placeholder="Invoice Type"
                                        isSearchable
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                minHeight: '30px',  // Minimum height of the dropdown
                                                height: '30px',
                                            }),
                                            valueContainer: (provided) => ({
                                                ...provided,
                                                height: '30px',
                                                padding: '0 6px',
                                            }),
                                            input: (provided) => ({
                                                ...provided,
                                                margin: 0,
                                                padding: 0,
                                            }),
                                            indicatorsContainer: (provided) => ({
                                                ...provided,
                                                height: '30px',
                                            }),
                                        }}
                                    />

                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        GST NO
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={GSTNumber}
                                        onChange={(e) => setGSTNumber(e.target.value)}
                                        type="text"
                                        placeholder="GST No"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        PAN NO
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={PanNumber}
                                        onChange={(e) => setPanNumber(e.target.value)}
                                        type="text"
                                        placeholder="PAN No"
                                    />
                                </div>


                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Contact NO 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CSContactNumber1}
                                        onChange={(e) => setCSContactNumber1(e.target.value)}
                                        type="text"
                                        placeholder="Contact No 1"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Contact NO 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CSContactNumber2}
                                        onChange={(e) => setCSContactNumber2(e.target.value)}
                                        type="text"
                                        placeholder="Contact No 2"
                                    />
                                </div>

                                <div className="w-1/3 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Email
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CSEmail}
                                        onChange={(e) => setCSEmail(e.target.value)}
                                        type="text"
                                        placeholder="Email"
                                    />
                                </div>
                            </div>
                        )}
                        {selectedMasterType === "Supplier" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Address Line 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CSAddressLine1}
                                        onChange={(e) => setCSAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="Address Line 1"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Address Line 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CSAddressLine2}
                                        onChange={(e) => setCSAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="Address Line 2"
                                    />
                                </div>
                            </div>
                        )}
                        {selectedMasterType === "Supplier" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Delivery Address Line 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CSDeliveryAddressLine1}
                                        onChange={(e) => setCSDeliveryAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="Delivery Address Line 1"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Delivery Address Line 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CSDeliveryAddressLine2}
                                        onChange={(e) => setCSDeliveryAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="Delivery Address Line 2"
                                    />
                                </div>
                            </div>
                        )}
                        {selectedMasterType === "Supplier" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Location
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={Location}
                                        onChange={(e) => setLocation(e.target.value)}
                                        type="text"
                                        placeholder="Location"
                                    />
                                </div>

                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        PIN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={Pincode}
                                        onChange={(e) => setPincode(e.target.value)}
                                        type="text"
                                        placeholder="PIN Code"
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        MRPL Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={MRPLCode}
                                        onChange={(e) => setMRPLCode(e.target.value)}
                                        type="text"
                                        placeholder="MRPL Code"
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Credit Days
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CreditDays}
                                        onChange={(e) => setCreditDays(e.target.value)}
                                        type="text"
                                        placeholder="Credit Days"
                                    />
                                </div>
                                <div className="w-1/8 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Credit Limit
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CreditLimit}
                                        onChange={(e) => setCreditLimit(e.target.value)}
                                        type="text"
                                        placeholder="Credit Limit"
                                    />
                                </div>
                            </div>
                        )}

                        {/* Bank */}
                        {selectedMasterType === "Bank" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/3 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Account Name
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={AccountName}
                                        onChange={(e) => setAccountName(e.target.value)}
                                        type="text"
                                        placeholder="Account Name"
                                    />
                                </div>
                                <div className="w-1/3 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Branch
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={BranchName}
                                        onChange={(e) => setBranchName(e.target.value)}
                                        type="text"
                                        placeholder="Branch"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        IFSC Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={IFSCCode}
                                        onChange={(e) => setIFSCCode(e.target.value)}
                                        type="text"
                                        placeholder="IFSC Code"
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Contact NO 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={BKContactNumber}
                                        onChange={(e) => setBKContactNumber(e.target.value)}
                                        type="text"
                                        placeholder="Contact NO 1"
                                    />
                                </div>
                            </div>
                        )}
                        {selectedMasterType === "Bank" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Address Line 1
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={BKAddressLine1}
                                        onChange={(e) => setBKAddressLine1(e.target.value)}
                                        type="text"
                                        placeholder="Address ine 1"
                                    />
                                </div>

                                <div className="w-1/2 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Address Line 2
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={BKAddressLine2}
                                        onChange={(e) => setBKAddressLine2(e.target.value)}
                                        type="text"
                                        placeholder="Address Line 2"
                                    />
                                </div>
                            </div>
                        )}

                        {/* AccountHead */}
                        {selectedMasterType === "Account Head" && (
                            <div className="w-full mb-3 flex">
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        CGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={CGSTRate}
                                        onChange={(e) => setCGSTRate(e.target.value)}
                                        type="text"
                                        placeholder="CGST Rate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        SGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={SGSTRate}
                                        onChange={(e) => setSGSTRate(e.target.value)}
                                        type="text"
                                        placeholder="SGst Rate"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        HSN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={HSNCode}
                                        onChange={(e) => setHSNCode(e.target.value)}
                                        type="text"
                                        placeholder="HSN Code"

                                    />
                                </div>

                                <div className="w-1/4 mb-4 flex justify-end items-center">
                                    <div className="flex justify-end items-center">
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode">
                                            <input
                                                type="radio"
                                                name="customerType"
                                                value="true"
                                                checked={IsExpenseOrIncome === true}
                                                onChange={handleAccoundHeadChange}
                                            />
                                            <span style={{ color: 'whitesmoke', fontSize: '12px' }}>Income</span>
                                        </label>
                                        <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ marginLeft: '10px' }}>
                                            <input
                                                type="radio"
                                                name="customerType"
                                                value="false"
                                                checked={IsExpenseOrIncome === false}
                                                onChange={handleAccoundHeadChange}
                                            />
                                            <span style={{ color: 'whitesmoke', fontSize: '12px' }}>Expense</span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Assets */}
                        {selectedMasterType === "Assets" && (
                            <div className="w-full mb-3 flex">

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Amount
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={ATAmount}
                                        onChange={(e) => setATAmount(e.target.value)}
                                        type="text"
                                        placeholder="Amount"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        Depreciation
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={ATDepreciation}
                                        onChange={(e) => setATDepreciation(e.target.value)}
                                        type="text"
                                        placeholder="Depreciation"

                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        CGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={ATCGSTRate}
                                        onChange={(e) => setATCGSTRate(e.target.value)}
                                        type="text"
                                        placeholder="CGSTRate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        SGST Rate
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={ATSGSTRate}
                                        onChange={(e) => setATSGSTRate(e.target.value)}
                                        type="text"
                                        placeholder="SGSTRate"

                                    />
                                </div>
                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="HSNCode" style={{ color: 'whitesmoke', fontFamily: 'monospace', fontSize: '13px' }}>
                                        HSN Code
                                    </label>
                                    <input
                                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline h-8"
                                        value={ATHSNCode}
                                        onChange={(e) => setATHSNCode(e.target.value)}
                                        type="text"
                                        placeholder="HSN Code"

                                    />
                                </div>
                            </div>
                        )}

                        <div className="w-1/2 mr-4 flex justify-center items-center gap-2" style={{ marginTop: '23px', marginLeft: '250px' }}>
                            <button
                                className="bg-green-500 hover:bg-green-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md transition duration-200"
                                onClick={addRecord}
                            >
                                Add
                            </button>
                            <button
                                className="bg-red-500 hover:bg-red-600 text-white text-xs font-semibold px-3 py-1 rounded-full shadow-md transition duration-200"
                                onClick={toggleModal}
                            >
                                Cancel
                            </button>
                        </div>

                    </div>

                </div>
            )}

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%' }}>

                {selectedIndexMasterTypeId === 1 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: 'teal' }}>
                                <TableRow>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Contact No</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Address</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Email</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>
                                {SearchfilteredData.map(item => (
                                    <TableRow key={item.masterId} sx={{
                                        '&:hover': { backgroundColor: 'whitesmoke' },
                                        transition: 'background-color 0.3s ease-in-out',
                                        cursor: 'pointer',
                                    }}
                                    >
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.name}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.searchableName}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.contactNumber1} , {item.contactNumber2}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.addressLine1}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.email}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right', fontFamily: 'monospace' }}>
                                            {hasEditMasterPermission && (
                                                <Tooltip
                                                    title="Capital Edit" arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#7965C1',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet', fontSize: '19px' }} />
                                                        </IconButton>
                                                    </Link>
                                                </Tooltip>
                                            )}

                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Capital Delete" arrow>
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ fontSize: '20px', color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>

                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>

                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>

                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

                {selectedIndexMasterTypeId === 2 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#1A4870' }}>
                                <TableRow>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Contact No</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>GST No</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Location</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>PinCode</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder', textAlign: 'right' }}>Credit Days</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder', textAlign: 'right' }}>Credit Limit</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'whitesmoke' }}>
                                {SearchfilteredData.map(item => (
                                    <TableRow
                                        key={item.masterId}
                                        className={item.isActive ? '' : 'inactiveRow'}
                                        sx={{
                                            backgroundColor: (() => {
                                                switch (item.customerType) {
                                                    case 1:
                                                        return '#D6DAC8';
                                                    case 2:
                                                        return '#FFEFEF';
                                                    default:
                                                        return 'white';
                                                }
                                            })(),
                                            '&:hover': {
                                                backgroundColor: 'whitesmoke',
                                            },
                                            transition: 'background-color 0.3s ease-in-out',
                                            cursor: 'pointer'
                                        }}
                                    >
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.name}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.searchableName}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.contactNumber1} , {item.contactNumber2}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.gstNumber}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.location}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace', textAlign: 'center' }}>{item.pinCode}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace', textAlign: 'right' }}>{item.creditDays}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace', textAlign: 'right' }}>{item.creditLimit}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right', fontFamily: 'monospace' }}>
                                            {hasEditMasterPermission && (
                                                <Tooltip
                                                    title="Supplier Edit" arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#7965C1',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                cursor: 'pointer'
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet', fontSize: '19px', cursor: 'pointer' }} />
                                                        </IconButton>
                                                    </Link>
                                                </Tooltip>
                                            )}

                                            {hasDeleteMasterPermission && (
                                                <Tooltip title="Supplier Delete" arrow>
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ fontSize: '20px', color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>

                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

                {selectedIndexMasterTypeId === 3 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: 'white' }}>
                                <TableRow>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Account Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Branch</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>IFS Code</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Contact No</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Address</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Remarks</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: '#DFF2EB' }}>
                                {SearchfilteredData.map(item => (
                                    <TableRow key={item.masterId} sx={{
                                        '&:hover': { backgroundColor: 'whitesmoke' },
                                        transition: 'background-color 0.3s ease-in-out',
                                        cursor: 'pointer'
                                    }}>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.name}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.searchableName}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.accountName}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.branchName}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.ifscCode}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.contactNumber}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.addressLine1}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.remarks}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right', fontFamily: 'monospace' }}>
                                            {hasEditMasterPermission && (
                                                <Tooltip
                                                    title="Bank Edit" arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#7965C1',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                cursor: 'pointer'
                                                            },
                                                        },
                                                    }}
                                                >
                                                    <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet', fontSize: '19px', cursor: 'pointer' }} />
                                                        </IconButton>
                                                    </Link>
                                                </Tooltip>
                                            )}
                                            {hasDeleteMasterPermission && (
                                                // <Tooltip
                                                //     title="Bank Delete" arrow
                                                //     componentsProps={{
                                                //         tooltip: {
                                                //             sx: {
                                                //                 backgroundColor: '#DA6C6C',
                                                //                 color: 'white',
                                                //                 border: '1px solid white',
                                                //                 fontWeight: 'bold',
                                                //                 boxShadow: 2,
                                                //                 cursor: 'pointer'
                                                //             },
                                                //         },
                                                //     }}>
                                                //     <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.masterId) : handleActivate(item.masterId))}>
                                                //         {item.isActive ? <DeleteIcon style={{ color: 'brown', fontSize: '19px', cursor: 'pointer' }} /> : <ActivateIcon />}
                                                //     </IconButton>
                                                // </Tooltip>
                                                <Tooltip title="Staff Delete " arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#DA6C6C',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                cursor: 'pointer'
                                                            },
                                                        },
                                                    }}>
                                                    <IconButton
                                                        onClick={() =>
                                                            item.isActive
                                                                ? openConfirmDialog(item.masterId)
                                                                : handleActivate(item.masterId)
                                                        }
                                                    >
                                                        {item.isActive ? (
                                                            <DeleteIcon style={{ fontSize: '20px', color: 'brown' }} />
                                                        ) : (
                                                            <ActivateIcon />
                                                        )}
                                                    </IconButton>
                                                </Tooltip>

                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog>
                        </Table>
                    </TableContainer>
                )}


                {selectedIndexMasterTypeId === 4 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#1A3636' }}>
                                <TableRow>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>CGST Rate</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>SGST Rate</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>HSNCode</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Expense Or Income</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Remarks</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>
                                {SearchfilteredData.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.name}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.searchableName}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.cgstRate}%</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.sgstRate}%</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.hsnCode}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}
                                            sx={{
                                                borderBottom: '1px solid #FFE1E2',
                                                height: '40px',
                                                padding: '5px',
                                                fontWeight: 'bold',
                                                color: item.isExpenseOrIncome ? 'green' : 'brown'
                                            }}
                                        >
                                            {item.isExpenseOrIncome ? 'INCOME' : 'EXPENSE'}
                                        </TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px' }}>{item.remarks}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right' }}>
                                            {hasEditMasterPermission && (
                                                <Tooltip
                                                    title="Account Head Edit" arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#7965C1',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                cursor: 'pointer'
                                                            },
                                                        },
                                                    }} >
                                                    <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet', fontSize: '19px' }} />
                                                        </IconButton>
                                                    </Link>
                                                </Tooltip>
                                            )}
                                            {/* {hasDeleteMasterPermission && (
                                                <Tooltip
                                                    title="Account Head Delete" arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#DA6C6C',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                cursor: 'pointer'
                                                            },
                                                        },
                                                    }}>
                                                    <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.masterId) : handleActivate(item.masterId))}>
                                                        {item.isActive ? <DeleteIcon style={{ color: 'brown', fontSize: '19px' }} /> : <ActivateIcon />}
                                                    </IconButton>
                                                </Tooltip>
                                            )} */}
                                            <Tooltip title="Account Head Delete " arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: '#DA6C6C',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                            cursor: 'pointer'
                                                        },
                                                    },
                                                }}>
                                                <IconButton
                                                    onClick={() =>
                                                        item.isActive
                                                            ? openConfirmDialog(item.masterId)
                                                            : handleActivate(item.masterId)
                                                    }
                                                >
                                                    {item.isActive ? (
                                                        <DeleteIcon style={{ fontSize: '20px', color: 'brown' }} />
                                                    ) : (
                                                        <ActivateIcon />
                                                    )}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

                {selectedIndexMasterTypeId === 5 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#674188' }}>
                                <TableRow>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Balance Sheet</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Remarks</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>
                                {SearchfilteredData.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.balancesheet}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.name}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.searchableName}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.remarks}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right', fontFamily: 'monospace' }}>
                                            {hasEditMasterPermission && (
                                                <Tooltip
                                                    title="Others Edit" arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#7965C1',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                cursor: 'pointer'
                                                            },
                                                        },
                                                    }} >
                                                    <Link to={`/CapitalEdit/${item.id}/${item.masterTypeId}`}>
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet', fontSize: '19px' }} />
                                                        </IconButton>
                                                    </Link>
                                                </Tooltip>
                                            )}

                                            <Tooltip title="Other Delete " arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: '#DA6C6C',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                            cursor: 'pointer'
                                                        },
                                                    },
                                                }}>
                                                <IconButton
                                                    onClick={() =>
                                                        item.isActive
                                                            ? openConfirmDialog(item.masterId)
                                                            : handleActivate(item.masterId)
                                                    }
                                                >
                                                    {item.isActive ? (
                                                        <DeleteIcon style={{ fontSize: '20px', color: 'brown' }} />
                                                    ) : (
                                                        <ActivateIcon />
                                                    )}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

                {selectedIndexMasterTypeId === 6 && (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead sx={{ backgroundColor: '#821131' }}>
                                <TableRow>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}>Searchable Name</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder', textAlign: 'right' }}>Amount</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder', textAlign: 'right' }}>Depreciation</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder', textAlign: 'right' }}>CGST Rate</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder', textAlign: 'right' }}>SGST Rate</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder', textAlign: 'center' }}>HSN Code</TableCell>
                                    <TableCell sx={{ color: 'white', backgroundColor: '#1A4870', fontSize: '10.5px', textTransform: 'uppercase', padding: '3px', fontWeight: 'bolder' }}></TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody style={{ backgroundColor: 'white' }}>
                                {SearchfilteredData.map(item => (
                                    <TableRow key={item.masterId} className={item.isActive ? '' : 'inactiveRow'}>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.name}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace' }}>{item.searchableName}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace', textAlign: 'right' }}>{item.amount}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace', textAlign: 'right' }}>{item.depreciation}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace', textAlign: 'right' }}>{item.cgstRate}%</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace', textAlign: 'right' }}>{item.sgstRate}%</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', fontFamily: 'monospace', textAlign: 'center' }}>{item.hsnCode}</TableCell>
                                        <TableCell className='table-header-cell.child' style={{ padding: '3px', textAlign: 'right', fontFamily: 'monospace' }}>
                                            {hasEditMasterPermission && (
                                                <Tooltip
                                                    title="Asset Edit" arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#7965C1',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                cursor: 'pointer'
                                                            },
                                                        },
                                                    }} >
                                                    <Link to={`/CapitalEdit/${item.masterId}/${item.masterTypeId}`}>
                                                        <IconButton>
                                                            <EditIcon style={{ color: 'blueviolet', fontSize: '19px' }} />
                                                        </IconButton>
                                                    </Link>
                                                </Tooltip>
                                            )}
                                            {/* {hasDeleteMasterPermission && (
                                                <Tooltip
                                                    title="Asset Delete" arrow
                                                    componentsProps={{
                                                        tooltip: {
                                                            sx: {
                                                                backgroundColor: '#DA6C6C',
                                                                color: 'white',
                                                                border: '1px solid white',
                                                                fontWeight: 'bold',
                                                                boxShadow: 2,
                                                                cursor: 'pointer'
                                                            },
                                                        },
                                                    }}>
                                                    <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.masterId) : handleActivate(item.masterId))}>
                                                        {item.isActive ? <DeleteIcon style={{ color: 'brown', fontSize: '19px' }} /> : <ActivateIcon />}
                                                    </IconButton>
                                                </Tooltip>
                                                
                                            )} */}
                                            <Tooltip
                                                title="Asset Delete " arrow
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: '#DA6C6C',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                            cursor: 'pointer'
                                                        },
                                                    },
                                                }}>
                                                <IconButton
                                                    onClick={() =>
                                                        item.isActive
                                                            ? openConfirmDialog(item.masterId)
                                                            : handleActivate(item.masterId)
                                                    }
                                                >
                                                    {item.isActive ? (
                                                        <DeleteIcon style={{ fontSize: '20px', color: 'brown' }} />
                                                    ) : (
                                                        <ActivateIcon />
                                                    )}
                                                </IconButton>
                                            </Tooltip>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                            <Dialog
                                open={confirmDialogOpen}
                                onClose={closeConfirmDialog}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        Are you sure you want to delete ?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <button
                                        onClick={closeConfirmDialog}
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#ffffff',
                                            border: '1px solid #dc3545',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                            marginRight: '8px',
                                        }}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        onClick={handleDelete}
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: '#ffffff',
                                            border: '1px solid #28a745',
                                            borderRadius: '4px',
                                            padding: '8px 16px',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        Confirm
                                    </button>
                                </DialogActions>
                            </Dialog>
                        </Table>
                    </TableContainer>
                )}

            </div>
        </div>
    );
}

export default MasterIndex;

